import React, { useEffect, useRef } from 'react'
import MolGrid from '../../../../components/Grid/MolGrid'
import { uploadCPDConfig } from '../dataFile/UploadCpdSearchForm.Data';
import FinalMolGrid from '../../../../components/FinalMolGrid/FinalMolGrid';
import Buttons from '../../../../components/ui/button/Buttons';
import { useUpdateCpdStatusToInvalidMutation } from '../../../../app/services/CPD/CPDApi';
import SwalAlert from '../../../../services/swalService/SwalService';
import { useCpdSelection } from '../UploadCpd';
import { GridColumnType } from '../../../../data/gridColumnType';
import { getAuthProps } from '../../../../lib/authenticationLibrary';

const UploadCpdDataGrid = (props) => {
    const molGridRef = useRef();
    const { contextData, setContextData } = useCpdSelection();
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [gridData, setGridData] = React.useState([]);
    const { success } = SwalAlert();
    useEffect(() => { getCPDList() }, [])
    useEffect(() => {
        if (props.dataSource) {
            const cloned = props.dataSource.map(item => {
                // Force both sides to the same type:
                const itemId = String(item.cpdSubmissionId);
                const hasIt = contextData.selectedIds.map(String).includes(itemId);
                return {
                    ...item,
                    isApprove: hasIt
                };
            });
            setGridData(cloned);
        }
    }, [props.dataSource]);

    const uploadCPDConfig = {
        columns: [
            {
                name: "Select",
                fieldName: "isApprove",
                colType: GridColumnType.CHECKBOX,
                colSettings: {
                    allowEdit: false,
                },
                allowShort: false
            },
            {
                name: "upload Date",
                fieldName: "uploadDate",
                allowShort: false,
                colType: GridColumnType.DATE,
                colSettings: {
                    format: 'DD MMM YYYY',
                }
            },
            {
                name: "Event Name",
                fieldName: "eventName",
                allowShort: false,
                colType: GridColumnType.Text,
            },
            {
                name: "Name",
                fieldName: "gmaName",
                allowShort: false,
                colType: GridColumnType.Text,
            },
            {
                name: "GMP Number",
                fieldName: "gmaNumber",
                allowShort: false,
                colType: GridColumnType.Text,
            },
            {
                name: "Status",
                fieldName: "status",
                colType: GridColumnType.Text,
            },
        ],
    };
    const getCPDList = (requestData) => {
        props.getUploadedCpdList({ ...props.paginationRequest, ...requestData })
    }
    const [updateCpdStatusToInvalid, { isSuccess: isSuccessUpdateCpdStatusToInvalid, isLoading: isLoadingUpdateCpdStatusToInvalid, data: updateCpdStatusToInvalidData, },] = useUpdateCpdStatusToInvalidMutation();

    useEffect(() => {
        if (!isLoadingUpdateCpdStatusToInvalid && isSuccessUpdateCpdStatusToInvalid && updateCpdStatusToInvalidData) {
            console.log(updateCpdStatusToInvalidData, "updateCpdStatusToInvalidData");
            success("Marked as Invalid Successfully");
            getCPDList();
        }
    }, [isLoadingUpdateCpdStatusToInvalid, isSuccessUpdateCpdStatusToInvalid, updateCpdStatusToInvalidData]);

    const handlePageChange = ({ pageNumber, pageSize }) => {
        console.log("Page Change", selectedRows);
        getCPDList({ ...props.paginationRequest, pageNo: pageNumber, pageSize: pageSize })
    }

    const handleRowSelection = (selectedRow) => {
        setSelectedRows((prevSelectedRows) => {
            const updatedRows = prevSelectedRows ? [...prevSelectedRows] : [];
            const rowExists = updatedRows.some((row) => row.cpdSubmissionId === selectedRow.cpdSubmissionId);
            if (rowExists) {
                return updatedRows.filter((row) => row.cpdSubmissionId !== selectedRow.cpdSubmissionId);
            } else {
                return [...updatedRows, selectedRow];
            }
        });
        const updatedData = gridData.map((item) =>
            item.cpdSubmissionId === selectedRow.cpdSubmissionId
                ? { ...item, isApprove: !item.isApprove }
                : item
        );
        setGridData(updatedData);

        const updatedSelectedIds = updatedData
            .filter((item) => item.isApprove)
            .map((item) => item.cpdSubmissionId);


        setContextData(prev => {
            // Start with whatever was already selected
            const merged = Array.from(
                new Set([
                    ...prev.selectedIds,    // all the old ones
                    ...updatedSelectedIds   // plus the newly checked ones
                ])
            );
            // if you find duplicate then remove duplicate id from merged arrary in future.
            return {
                ...prev,
                selectedIds: Array.from(merged),
            };
        });


        //  setContextData({ selectedIds: updatedSelectedIds });
    };

    const handleSearch = () => {
        let authData = getAuthProps();

        const request = {
            UpdateCpdStatusToInvalidList: selectedRows.map((item) => ({
                CpdSubmissionId: item.cpdSubmissionId || null,
                GMPNumber: item.gmaNumber || null,
                UpdatedBy : 115,
                UpdatedAppId : authData?.adminUserId
                // IsApprove: item.isApprove || false,
            })),
        };
        console.log("Request to save:", request);
        updateCpdStatusToInvalid(request);
    }

    return (
        <div className='mt-2'>
            <div className=''>
                {gridData &&
                    <FinalMolGrid
                        ref={molGridRef}
                        configuration={uploadCPDConfig}
                        dataSource={gridData}
                        allowPagination={true}
                        isLoading={props.isLoading}
                        pagination={props.paginationRequest}
                        onPageChange={handlePageChange}
                        onHandleRowSelect={handleRowSelection}
                    // onActionChange={actionHandler}
                    />}
            </div>
            <div className="mt-2">
                <Buttons
                    buttonText="Submit"
                    buttonTypeClassName="success-btn mt-4"
                    onClick={handleSearch}
                />
            </div>
        </div>
    )
}

export default UploadCpdDataGrid
